const SectionTerms = Class(
	/**
	 * @lends {SectionTerms#}
	 */
	{
		bodyClass: 'small-nav',
		menuItem: 'terms',
		eventSlug: null,

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'terms',
				className: 'container'
			}).append(this.layout.ct());
		},

		route() {
			this.eventSlug = this.url.shift();
		},

		draw() {
			this.rules = new T.Rules.Api({
				apiCall: this.apiCall,
				onError: D.closure(this, function (error) {
					if (error === 'no event') {
						const section = new SectionUnknown();
						section.url = this.url;
						section.show();
					}
				}),
				smallRules: true,
				type: 'rules'
			}).append(this.node);

			this.apiCall.call({
				eventSeoTitle: this.eventSlug
			});
		},

		onShow() {
			if (this.rules) {
				this.rules.scrollIntoView(location.hash.replace('#', ''));
			}
		}
	},
	Section
);
